import { createContext } from "react";

const FormContext = createContext({});

export { FormContext };
